import { Link } from 'react-router-dom';

interface PlatformCardProps {
  name: string;
  slug: string;
  description: string;
  rating: number;
  features: string[];
  imageUrl: string;
  tags: string[];
  isFeatured?: boolean;
}

export default function PlatformCard({ name, slug, description, rating, features, imageUrl, tags, isFeatured }: PlatformCardProps) {
  return (
    <article className="bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300 group">
      <div className="relative h-48 overflow-hidden">
        <img
          src={imageUrl}
          alt={`${name}平台截图`}
          title={`${name} - 免费看片平台推荐`}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        {isFeatured && (
          <span className="absolute top-3 left-3 bg-primary-500 text-background-50 text-xs px-2 py-0.5 rounded-full font-medium">
            推荐
          </span>
        )}
        <div className="absolute top-3 right-3 bg-background-50/90 text-primary-500 text-xs px-2 py-0.5 rounded-full font-semibold flex items-center gap-1">
          <i className="ri-star-fill w-3 h-3 flex items-center justify-center"></i>
          {rating}
        </div>
      </div>
      <div className="p-4">
        <Link to={`/article/${slug}`} className="block">
          <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2 hover:text-primary-500 transition-colors">
            {name}
          </h3>
        </Link>
        <p className="text-sm text-foreground-600 leading-relaxed mb-3 line-clamp-2">{description}</p>
        <div className="flex flex-wrap gap-1.5 mb-3">
          {features.slice(0, 4).map((feature) => (
            <span key={feature} className="text-xs bg-secondary-100 text-secondary-700 px-2 py-0.5 rounded-full whitespace-nowrap">
              {feature}
            </span>
          ))}
        </div>
        <div className="flex items-center justify-between">
          <div className="flex gap-1.5">
            {tags.map((tag) => (
              <span key={tag} className="text-xs text-foreground-500 bg-background-100 px-1.5 py-0.5 rounded whitespace-nowrap">
                {tag}
              </span>
            ))}
          </div>
          <Link
            to={`/article/${slug}`}
            className="text-sm text-primary-500 hover:text-primary-600 font-medium flex items-center gap-1 whitespace-nowrap"
          >
            查看详情
            <i className="ri-arrow-right-line w-3 h-3 flex items-center justify-center"></i>
          </Link>
        </div>
      </div>
    </article>
  );
}